import React from "react";
import { Helmet } from "react-helmet-async";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DuplicateList from "../../components/List/DuplicateList.js";
import MainHeader from "../../components/MainHeader/MainHeader.js";
function DuplicateApplications({ t }) {
  const navigate = useNavigate();
  return (
    <>
      <MainHeader title={t("Duplicate Application list")}></MainHeader>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Duplicate Application list")}</title>
      </Helmet>
      <div>
        <DuplicateList />
      </div>
    </>
  );
}
export default withTranslation()(DuplicateApplications);
